import { render, staticRenderFns } from "./GroupsOfPerson.vue?vue&type=template&id=540ecb6a&"
import script from "./GroupsOfPerson.vue?vue&type=script&lang=js&"
export * from "./GroupsOfPerson.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports